import { Result } from "appworks/model/gameplay/records/results/result";
import { Point } from "appworks/utils/geom/point";

export class SparkResult extends Result {
    /** For debugging purposes */
    public resultType: string = "SparkResult";

    public positions: Point[];
    public emitPositions: Point[];
    public upgrade: boolean;
    public state: number;
}
